module.exports = __webpack_public_path__ + "static/unity-eye-tile-image@2x-43422cb24130149bee2818ea48e12581.jpg";